module.exports = __webpack_public_path__ + "img/VANLANSCHOT.9975482f.jpg";